import { render, staticRenderFns } from "./ModalCard.vue?vue&type=template&id=e27c4b0c"
import script from "./ModalCard.vue?vue&type=script&lang=js"
export * from "./ModalCard.vue?vue&type=script&lang=js"
import style0 from "./ModalCard.vue?vue&type=style&index=0&id=e27c4b0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports